var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_665_27881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5 21H19.5C19.3674 21 19.2402 21.0527 19.1464 21.1464C19.0527 21.2402 19 21.3674 19 21.5V30.5C19 30.6326 19.0527 30.7598 19.1464 30.8536C19.2402 30.9473 19.3674 31 19.5 31H33.5C33.6326 31 33.7598 30.9473 33.8536 30.8536C33.9473 30.7598 34 30.6326 34 30.5V21.5C34 21.3674 33.9473 21.2402 33.8536 21.1464C33.7598 21.0527 33.6326 21 33.5 21ZM26.5 26.91L20.08 21.91H33.05L26.5 26.91ZM23.8 26L19.89 29.55V23L23.8 26ZM24.6 26.62L26.22 27.89C26.3005 27.9535 26.3979 27.9917 26.5 28C26.6116 28.0022 26.7207 27.967 26.81 27.9L28.41 26.67L32.22 30.1H20.75L24.6 26.62ZM29.24 26.04L33.12 23.04V29.51L29.24 26.04Z",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "#E5E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_665_27881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(16.5 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/IconMail.a3199352e2932040cdb06796779ac8e5.svg";
export { ForwardRef as ReactComponent };